module.exports = __webpack_public_path__ + "static/media/logo.712a9c28.png";